import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";

import { getDomainsInfo } from "../../../store/ducks/duckAuth";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function SearchUserInput() {
  const classes = useStyles();
  const [username, setUserName] = useState("");
  const dispatch = useDispatch();

  return (
    <Paper className={classes.root} component="form">
      <InputBase
        className={classes.input}
        inputProps={{ "aria-label": "search user info" }}
        placeholder="Search User Info"
        value={username}
        onChange={(e) => {
          e.preventDefault();
          setUserName(e.target.value);
          let key = e.keyCode || e.which;

          key === 13 && dispatch(getDomainsInfo(username));
        }}
      />
      <IconButton
        aria-label="search"
        className={classes.iconButton}
        onClick={() => dispatch(getDomainsInfo(username))}
      >
        <SearchIcon />
      </IconButton>
      <Divider className={classes.divider} orientation="vertical" />
    </Paper>
  );
}
